function loadMMKVModule() {
    try {
        return require('react-native-mmkv');
    } catch (error) {
        const missingModuleError = new Error(
            'persistedRestate on React Native requires react-native-mmkv. ' +
            'Install the native module and complete its platform build setup.'
        );
        missingModuleError.cause = error;
        throw missingModuleError;
    }
}

function createMMKVInstance(options) {
    if (options.mmkv) return options.mmkv;

    const mmkvModule = options.mmkvModule ?? loadMMKVModule();
    const configuration = options.configuration ?? (
        options.id == null ? undefined : { id: options.id }
    );

    if (typeof mmkvModule.createMMKV === 'function') {
        return mmkvModule.createMMKV(configuration);
    }
    if (typeof mmkvModule.MMKV === 'function') {
        return new mmkvModule.MMKV(configuration);
    }
    throw new TypeError('The installed react-native-mmkv package has no supported factory.');
}

export function createMMKVStorage(options = {}) {
    const mmkv = createMMKVInstance(options);

    return Object.freeze({
        kind: 'mmkv',
        isAvailable: () => true,
        getItem(key) {
            return mmkv.getString(key) ?? null;
        },
        setItem(key, value) {
            mmkv.set(key, value);
        },
        removeItem(key) {
            if (typeof mmkv.remove === 'function') {
                mmkv.remove(key);
                return;
            }
            if (typeof mmkv.delete === 'function') {
                mmkv.delete(key);
                return;
            }
            throw new TypeError('The installed MMKV instance cannot remove values.');
        },
        clear() {
            mmkv.clearAll();
        },
    });
}
